export function getHostnameFromURL(url) {
	let hostname = ''

	if (typeof url !== 'string' || !url.length) {
		return hostname
	}

	try {
		hostname = new URL(url).hostname
	} catch (e) {}

	return hostname
}

export function safeDecodeURIComponent(str) {
	try {
		return decodeURIComponent(str)
	} catch {
		return str
	}
}

export function getQueryParamsFromUrl(url) {
	let queryParams = {}

	try {
		const urlObject = new URL(url)
		const searchParamsEntries = urlObject.searchParams.entries()

		queryParams = Object.fromEntries(searchParamsEntries)
	} catch (e) {}

	return queryParams
}
